import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const CompanyIntro = () => {
  const fullText = `At MyTicketer, we take pride in being one of Sri Lanka's premier travel agencies, specializing in corporate travel services. With over two decades of industry experience, our dedicated and highly trained team is committed to providing top-tier service, handling all your travel needs with efficiency and care.`;

  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (index < fullText.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + fullText.charAt(index));
        setIndex(index + 1);
      }, 20);
      return () => clearTimeout(timeout);
    } else {
      setFinished(true);
    }
  }, [index]);

  return (
    <section className="py-20 bg-white flex flex-col justify-center items-center px-6 md:px-20">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="max-w-6xl text-center text-lg md:text-xl text-gray-700 leading-relaxed font-medium"
      >
        <p className="whitespace-pre-wrap">{displayedText}</p>

        {finished && (
          <motion.h2
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="mt-10 text-2xl md:text-3xl font-bold text-amber-400"
          >
            “Seamless Travel, Trusted by Professionals.”
          </motion.h2>
        )}
      </motion.div>
    </section>
  );
};

export default CompanyIntro;
